import React, { Component } from 'react';
import { UserAgentApplication } from 'msal';             // v1 browser lib
import { Modal, Button, Row, Col, Form, Image, ButtonToolbar } from 'react-bootstrap';
import logo from '../Images/derrick_full_logo.png';
import { msalConfig } from './MsalConfig';               // must be { auth:{...}, cache:{...} }

// 🔑 Your API delegated scope (must exist on the API app)
const apiScopes = ["api://b59a6520-0ff1-42e7-89cd-08e7db47930a/access_as_user"];
// OIDC + API scopes for loginRedirect (consent once)
const loginRequest = { scopes: ["openid", "profile", ...apiScopes] };

// ✅ MSAL v1 instance (fix: pass full config, not { auth: msalConfig })
export const msalAuth = new UserAgentApplication(msalConfig);

export function withAuth(HocComponent) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                isAuthenticated: false,
                user: {},
                renewIframe: false,
                hasError: false,
                errorMessage: null,
                requestID: 0,
                accessToken: null,              // <-- NEW: keep the API token
            };
        }

        // Prefer componentDidMount over deprecated componentWillMount
        async componentDidMount() {
            // Preserve ReqID and clean URL
            if (window.location.href.includes("ReqID")) {
                const sp = new URLSearchParams(window.location.search);
                sessionStorage.setItem("ReqID", sp.get("ReqID") ?? "0");
                window.history.replaceState({}, "", window.location.origin);
            } else if (!sessionStorage.getItem("ReqID")) {
                sessionStorage.setItem("ReqID", "0");
            }

            // Handle redirect results (login/token)
            msalAuth.handleRedirectCallback(
                async () => {
                    const userAccount = msalAuth.getAccount();
                    if (userAccount) {
                        this.setState({ isAuthenticated: true, user: userAccount });
                        sessionStorage.setItem("userName", userAccount.userName);
                        //await this.getToken();      // <-- NEW: fetch token right after login
                    }
                },
                (authErr) => {
                    this.setState({ hasError: true, errorMessage: authErr.errorMessage });
                }
            );

            // If we’re in the middle of a hidden iframe renew, bail out of rendering
            if (msalAuth.isCallback(window.location.hash)) {
                this.setState({ renewIframe: true });
                return;
            }

            // Already signed in?
            const userAccount = msalAuth.getAccount();
            if (userAccount) {
                this.setState({
                    isAuthenticated: true,
                    user: userAccount,
                    requestID: sessionStorage.getItem("ReqID"),
                });
                sessionStorage.setItem("userName", userAccount.userName);
                //await this.getToken();          // <-- NEW: get token on mount
            }
        }

        // 🔓 Start login (request OIDC + API scope)
        onSignIn = () => msalAuth.loginRedirect(loginRequest);

        onSignOut = () => {
            sessionStorage.setItem("isClickOnLogin", "false");
            msalAuth.logout();
        };

        // 👉 Call this to ensure you have an access token (silent → popup fallback)
        //getToken = async () => {
        //    const account = msalAuth.getAccount();
        //    if (!account) {
        //        // Not signed in: start login
        //        msalAuth.loginRedirect(loginRequest);
        //        return null;
        //    }

        //    try {
        //        const resp = await msalAuth.acquireTokenSilent({ scopes: apiScopes, account });
        //        this.setState({ accessToken: resp.accessToken });
        //        return resp.accessToken;
        //    } catch (e) {
        //        // If consent/MFA/CA required, interactive popup will handle it
        //        const pop = await msalAuth.acquireTokenPopup({ scopes: apiScopes });
        //        this.setState({ accessToken: pop.accessToken });
        //        return pop.accessToken;
        //    }
        //};

        // 🛠 Example protected API call using the token
        //loadAdpEmpList = async () => {
        //    let { accessToken } = this.state;
        //    if (!accessToken) accessToken = await this.getToken();
        //    if (!accessToken) return null;

        //    const API_BASE = "https://healthscreenap.azurewebsites.net"; // or https://localhost:7060
        //    const url = new URL("/AdpEmployeeList/GetAdpEmpList", API_BASE);
        //    const res = await fetch(url.toString(), {
        //        headers: { Authorization: `Bearer ${accessToken}` },
        //    });
        //    if (!res.ok) throw new Error(`HTTP ${res.status}`);
        //    return res.json();
        //};

        // Your existing "Sign In" button path
        fnLogin = () => {
            sessionStorage.setItem("isClickOnLogin", "true");
            // Trigger redirect flow with API scope so consent includes the API
            this.onSignIn();
        };

        render() {
            if (this.state.renewIframe) {
                return <div>hidden renew iframe - not visible</div>;
            }
            if (this.state.hasError) {
                return <div>{this.state.errorMessage}</div>;
            }
            if (this.state.isAuthenticated) {
                return (
                    <HocComponent
                        auth={this.state}
                        onSignIn={this.onSignIn}
                        onSignOut={this.onSignOut}
                        getToken={this.getToken}                 // <-- expose token getter
                        loadEmployees={this.loadAdpEmpList}      // <-- example API call
                        accessToken={this.state.accessToken}     // <-- current token if you need it
                        Url={window.location.href}
                        {...this.props}
                    />
                );
            }

            // ---- Sign-in screen (left as-is, you can tweak styles) ----
            return (
                <>
                    <div id="root">
                        <div class="container-fluid">
                            <div class="row" style={{ marginTop: "0%", marginLeft: "-18%", backgroundColor: "black", width: "100%" }}>
                                <img src={logo} class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3" style={{ flex: "0 0 23%", maxWidth: "20%" }} alt="Derrick" />
                            </div>
                            <div class="row" style={{ textAlign: "Center", marginTop: "5%" }}>
                                <span class="h1 mx-auto">Derrick | DRR Engineering &nbsp;&nbsp;</span>
                            </div>
                            <div class="row" style={{ textAlign: "Center", marginTop: "2%", display: "block" }}>
                                <button
                                    class="btn btn-light"
                                    style={{ width: "200px", border: "solid", borderColor: "#007935", borderWidth: "2px", color: "black", fontWeight: "500", fontFamily: "Segoe UI", fontSize: "16px" }}
                                    onClick={this.fnLogin}
                                >
                                    <span style={{ fontSize: "18px", margin: "3px 3px 5px 3px", whiteSpace: "nowrap", padding: "0px 30px 0px 30px", color: "#3d3131" }}>
                                        Sign In
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
    };
}
